import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { VALIDATE_RESET_TOKEN_QUERY } from "@/graphql/auth";

export function useTokenValidation(token: string | null) {
  const [isValid, setIsValid] = useState(false);
  const [validationMessage, setValidationMessage] = useState<string | undefined>();

  const { loading, data, error } = useQuery(VALIDATE_RESET_TOKEN_QUERY, {
    variables: {
      input: {
        token: token || "",
      },
    },
    skip: !token,
    fetchPolicy: "network-only", // Always fetch from network, don't use cache
  });

  useEffect(() => {
    if (!token) {
      setIsValid(false);
      setValidationMessage("No reset token provided");
      return;
    }

    if (data?.validateResetToken) {
      setIsValid(data.validateResetToken.valid);
      setValidationMessage(data.validateResetToken.message || undefined);
    }

    if (error) {
      setIsValid(false);
      setValidationMessage("An error occurred while validating the reset token");
    }
  }, [token, data, error]);

  return {
    isValidating: loading,
    isValid,
    validationMessage,
  };
}
